import { useEffect, useState } from 'react';

export function useOverflow(ref: any) {
  const [overflowActive, setOverflowActive] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isOverflowActive = (event: HTMLElement) => event.offsetWidth < event.scrollWidth;

  useEffect(() => {
    if (ref && isOverflowActive(ref)) {
      setOverflowActive(true);
    } else {
      setOverflowActive(false);
    }
  }, [isOverflowActive, ref]);

  return { overflowActive };
}
